import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "lib/globalEvent";
import { ConfigProvider } from "antd";
import { googleSSOClientId } from "lib/constants";
import AuthProvider from "context/AuthContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
//@ts-ignore
import wasm from "./main.wasm";
//@ts-ignore
window.__wasmURL = wasm;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "inherit",
        },
        components: {
          Popover: {
            colorBgElevated: "#303030",
            colorText: "#FFFFFF",
          },
          Dropdown: {
            paddingBlock: "5px 15px",
            controlItemBgHover: "#F5F5F5",
            controlItemBgActive: "#DCE7FD",
          },
          Tabs: {
            inkBarColor: "rgba(34, 34, 34, 1)",
            itemColor: "rgba(113, 113, 113, 1)",
            itemActiveColor: "rgba(34, 34, 34, 1)",
            itemSelectedColor: "rgba(34, 34, 34, 1)",
            itemHoverColor: "rgba(34, 34, 34, 1)",
          },
        },
      }}
    >
      <GoogleOAuthProvider clientId={googleSSOClientId}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </GoogleOAuthProvider>
    </ConfigProvider>
  </BrowserRouter>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
